import { ref } from 'vue';
import UsersAPI from '@/api/users';

export function useUserDetails() {
  const userDetails = ref({});

  const fetchUserDetails = async (userId) => {
    const response = await UsersAPI.getUserDetails(userId);

    console.log(response);

    userDetails.value = response;
  };

  return {
    userDetails,
    fetchUserDetails
  };
}
